/* BrameCam — barre d'achat mobile (v3, 13/09/2026)
   Reprend la main sur <sticky-atc> pour les fiches equipees du bloc packs.

   Regle d'apparition : la barre sort des que le prix a quitte le haut de
   l'ecran, et elle y reste. Elle ne s'efface que si le vrai bouton
   d'ajout de la fiche vient occuper le bas de l'ecran, c'est-a-dire la
   place exacte de la barre : on evite le chevauchement, pas le doublon.

   v2 (abandonnee) : la barre se retirait des que le bouton de la fiche
   etait visible n'importe ou a l'ecran. Sur mobile ce bouton est plus
   d'un ecran sous le prix : la barre sortait tot, disparaissait pendant
   tout le bloc packs, et ne revenait durablement qu'au meme endroit
   qu'avant. Gain nul a l'usage.

   L'ancien reglage inline de la fiche continue de poser ses classes
   (bc-pack-gated / bc-bundle-synced / bc-pack-passed) : ses regles CSS
   portent un selecteur d'ID, donc elles gagneraient sur les notres. On
   les retire en continu plutot que d'essayer de surencherir.

   Si ce script ne s'execute pas, la fiche retombe sur l'ancien reglage. */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 749px)');
  var LEGACY = ['bc-pack-gated', 'bc-bundle-synced', 'bc-pack-passed'];

  function strip(bar) {
    for (var i = 0; i < LEGACY.length; i++) {
      if (bar.classList.contains(LEGACY[i])) bar.classList.remove(LEGACY[i]);
    }
    if (!bar.classList.contains('bc-atc')) bar.classList.add('bc-atc');
  }

  function setup() {
    var bar = document.querySelector('sticky-atc');
    if (!bar || bar.getAttribute('data-bc-atc') === '1') return;

    /* On ne touche qu'aux fiches deja passees au reglage BrameCam. */
    var eligible =
      bar.classList.contains('bc-pack-gated') ||
      bar.classList.contains('bc-bundle-synced') ||
      !!document.querySelector('[data-bc-pack]');
    if (!eligible) return;

    bar.setAttribute('data-bc-atc', '1');
    strip(bar);

    /* L'ancien script repose ses classes au scroll : on les balaie. */
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        strip(bar);
      }).observe(bar, { attributes: true, attributeFilter: ['class'] });
    }

    var info = document.querySelector('product-info') || document;
    var anchor =
      info.querySelector('.price') ||
      info.querySelector('.product__title') ||
      info.querySelector('h1');
    var inline =
      document.querySelector('.bc-pack__cta') ||
      info.querySelector('.product-form__submit');

    var ticking = false;

    function evaluate() {
      ticking = false;

      if (!MQ.matches) {
        bar.classList.remove('bc-atc--on');
        document.body.classList.remove('bc-atc-visible');
        return;
      }

      /* 1. Le prix a-t-il quitte le haut de l'ecran ? */
      var passed = true;
      if (anchor) passed = anchor.getBoundingClientRect().bottom <= 0;

      /* 2. Le bouton de la fiche occupe-t-il la place de la barre ? */
      var collides = false;
      if (inline) {
        var zone = bar.offsetHeight || 80;
        var r = inline.getBoundingClientRect();
        collides =
          r.bottom > window.innerHeight - zone - 8 && r.top < window.innerHeight;
      }

      var on = passed && !collides;
      bar.classList.toggle('bc-atc--on', on);
      document.body.classList.toggle('bc-atc-visible', on);
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluate);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (MQ.addEventListener) MQ.addEventListener('change', schedule);
    else if (MQ.addListener) MQ.addListener(schedule);

    evaluate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  /* Editeur de theme : la section produit peut etre re-rendue. */
  document.addEventListener('shopify:section:load', setup);
})();